import React, { useState } from 'react';
import { api } from '../lib/api';
import { OperaWindow, OperaSection, OperaField } from './OperaWindow';

interface Props {
  roomId: string;
  roomNumber: string;
  roomDisplayName: string | null;
  currentStatus: 'CLEAN' | 'DIRTY';
  onClose: () => void;
  onChanged: () => void;
}

const STATUS_LABEL: Record<string, string> = {
  CLEAN: 'Clean',
  DIRTY: 'Dirty',
};

export function HousekeepingFlipModal({ roomId, roomNumber, roomDisplayName, currentStatus, onClose, onChanged }: Props) {
  const targetStatus: 'CLEAN' | 'DIRTY' = currentStatus === 'CLEAN' ? 'DIRTY' : 'CLEAN';
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleConfirm() {
    setBusy(true);
    setError(null);
    try {
      await api.setRoomHousekeeping(roomId, targetStatus, note.trim());
      onChanged();
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      setBusy(false);
    }
  }

  const roomDesc = roomDisplayName
    ? `Room ${roomNumber} — ${roomDisplayName}`
    : `Room ${roomNumber}`;

  return (
    <OperaWindow
      title="HOUSEKEEPING"
      status={currentStatus}
      onClose={onClose}
      size="compact"
      sideButtons={[
        { label: 'Confirm', onClick: handleConfirm, primary: true, disabled: busy },
        { label: 'Cancel',  onClick: onClose, disabled: busy },
      ]}
    >
      {error && <div className="modal-error">{error}</div>}

      <OperaSection title="Change Housekeeping Status">
        <OperaField label="Room">
          <span className="opera-readonly-strong">{roomDesc}</span>
        </OperaField>
        <OperaField label="Current">
          <span>{STATUS_LABEL[currentStatus]}</span>
        </OperaField>
        <OperaField label="Change to">
          <span className="opera-readonly-strong">{STATUS_LABEL[targetStatus]}</span>
        </OperaField>
        <OperaField label="Note">
          <input
            type="text"
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder="optional — e.g. linen changed, vacuumed"
          />
        </OperaField>
      </OperaSection>

      <div style={{ fontSize: 11, color: '#555', marginTop: 8 }}>
        Action will be recorded in the housekeeping log.
      </div>
    </OperaWindow>
  );
}
